import { CigarSearchParams } from '@store/api/cigarApi'
import { CollectionFilters } from '../types/filters'

export function filtersToSearchParams(filters: CollectionFilters): CigarSearchParams {
  return {
    search: filters.search,
    brandId: filters.brandId,
    wrapperType: filters.wrapperType,
    strengthLevel: filters.strengthLevel,
    vitolaId: filters.vitolaId,
    status: filters.status,
    origin: filters.origin,
    purchaseDateStart: filters.purchaseDateStart,
    purchaseDateEnd: filters.purchaseDateEnd,
    sortBy: filters.sortBy as CigarSearchParams['sortBy'],
    sortOrder: filters.sortOrder,
    page: filters.page,
    limit: filters.limit,
  }
}
